import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Excursions = () => {
  const [naivashaImage, setNaivashaImage] = useState(0);
  const [wildlifeImage, setWildlifeImage] = useState(0);
  const [activeTour, setActiveTour] = useState("naivasha");

  const naivashaImages = ["/images/Naiv1.jpeg", "/images/Naiv2.jpeg"];
  const wildlifeImages = ["/images/Nai1.jpeg", "/images/Nai2.jpeg"];

  useEffect(() => {
    const interval = setInterval(() => {
      setNaivashaImage((prev) => (prev + 1) % naivashaImages.length);
      setWildlifeImage((prev) => (prev + 1) % wildlifeImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const naivashaItinerary = [
    { time: "8:00 AM", icon: "🚐", title: "Departure from Nairobi", desc: "Pick-up from hotel/residence. Briefing by tour guide, then drive through the Great Rift Valley viewpoint." },
    { time: "10:30 AM", icon: "🚤", title: "Arrival at Lake Naivasha", desc: "Enjoy a 1-hour boat ride spotting hippos, fish eagles, and pelicans." },
    { time: "11:30 AM", icon: "🦒", title: "Crescent Island Sanctuary", desc: "Guided walking safari among giraffes, zebras, wildebeests, and impalas." },
    { time: "1:00 PM", icon: "🍽️", title: "Lunch Break", desc: "Lunch at a lakeside lodge — Lake Naivasha Sopa Lodge or Elsamere Conservation Centre." },
    { time: "2:30 PM", icon: "🚵", title: "Transfer to Hell's Gate", desc: "Optional cycling or drive-in safari through dramatic cliffs and gorges." },
    { time: "3:00 PM", icon: "⛰️", title: "Explore Hell's Gate", desc: "Visit Fischer's Tower, Central Tower, and the spectacular Ol Njorowa Gorge." },
    { time: "4:30 PM", icon: "🌄", title: "Depart for Nairobi", desc: "Drive back with a stop at Rift Valley viewpoint for photos." },
    { time: "6:30 PM", icon: "🏨", title: "Arrival in Nairobi", desc: "Drop-off at hotel or residence. End of tour." },
  ];

  const wildlifeItinerary = [
    { time: "7:30 AM", icon: "🚐", title: "Pick-Up from Hotel", desc: "Meet and greet with guide, briefing on the day's activities." },
    { time: "8:00 AM", icon: "🦒", title: "Giraffe Centre", desc: "Learn about conservation of Rothschild giraffes and feed them from raised platforms." },
    { time: "9:30 AM", icon: "🐘", title: "David Sheldrick Elephant Orphanage", desc: "Watch baby elephants being fed milk and playing in the mud." },
    { time: "12:30 PM", icon: "🍽️", title: "Lunch Break", desc: "Lunch at Tamarind Tree Hotel, Carnivore Restaurant, or Karen Blixen Coffee Garden." },
    { time: "2:00 PM", icon: "🦁", title: "Nairobi Safari Walk", desc: "Guided boardwalk tour spotting lions, leopards, zebras, and rhinos." },
    { time: "4:00 PM", icon: "🏨", title: "Depart for Hotel", desc: "Drive back to your Nairobi hotel. End of an unforgettable day." },
  ];

  const tours = {
    naivasha: {
      label: "Naivasha Excursion",
      price: "$120",
      duration: "Full Day",
      tagline: "Lake · Wildlife · Adventure",
      desc: "Discover Lake Naivasha's serene beauty — from boat rides spotting hippos and fish eagles, to walking safaris among giraffes at Crescent Island, to thrilling adventures through Hell's Gate's dramatic cliffs and gorges.",
      itinerary: naivashaItinerary,
      images: naivashaImages,
      currentImage: naivashaImage,
      setImage: setNaivashaImage,
      pills: ["Full Day", "$120 Per Person", "Hippos & Giraffes", "Hell's Gate"],
      stats: [
        { n: "1hr", l: "Boat Ride" },
        { n: "8hrs", l: "Duration" },
        { n: "$120", l: "Per Person" },
        { n: "5★", l: "Rated" },
      ],
    },
    wildlife: {
      label: "Nairobi Wildlife Excursion",
      price: "$100",
      duration: "4–5 Hours",
      tagline: "Giraffes · Elephants · Safari Walk",
      desc: "Experience Kenya's wildlife treasures without leaving the city — feed Rothschild giraffes from raised platforms, witness baby elephants at play, then explore the Nairobi Safari Walk where lions, leopards, and rhinos roam free.",
      itinerary: wildlifeItinerary,
      images: wildlifeImages,
      currentImage: wildlifeImage,
      setImage: setWildlifeImage,
      pills: ["4–5 Hours", "$100 Per Person", "Giraffes & Elephants", "Safari Walk"],
      stats: [
        { n: "3", l: "Wildlife Sites" },
        { n: "4–5", l: "Hours" },
        { n: "$100", l: "Per Person" },
        { n: "5★", l: "Rated" },
      ],
    },
  };

  const active = tours[activeTour];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C97A;
          --dark: #0A0A0A;
          --charcoal: #141414;
        }

        .ex-root {
          font-family: 'Jost', sans-serif;
          background: var(--dark);
          color: #fff;
          min-height: 100vh;
        }

        /* ── PAGE HERO ── */
        .ex-page-hero {
          background: linear-gradient(160deg, #0d0b06 0%, #1a1500 55%, #0A0A0A 100%);
          border-bottom: 1px solid rgba(201,168,76,0.2);
          padding: 5rem 1.5rem 3.5rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .ex-page-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 70% 60% at 50% 100%, rgba(201,168,76,0.06) 0%, transparent 70%);
          pointer-events: none;
        }
        .ex-eyebrow {
          font-size: 0.68rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.8rem;
        }
        .ex-page-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.8rem, 7vw, 4.8rem);
          font-weight: 700;
          color: #fff;
          line-height: 1.05;
          margin-bottom: 0.4rem;
        }
        .ex-page-title em { font-style: italic; color: var(--gold-light); }
        .ex-page-divider {
          width: 50px;
          height: 2px;
          background: var(--gold);
          margin: 1.2rem auto 1.5rem;
        }
        .ex-page-sub {
          font-size: clamp(0.88rem, 2vw, 1rem);
          font-weight: 300;
          color: rgba(255,255,255,0.55);
          max-width: 540px;
          margin: 0 auto;
          line-height: 1.85;
        }

        /* ── TOUR SWITCHER ── */
        .ex-switcher {
          background: var(--charcoal);
          border-bottom: 1px solid rgba(201,168,76,0.12);
          padding: 1.5rem 1rem;
        }
        .ex-switch-wrap {
          display: flex;
          justify-content: center;
          gap: 0.8rem;
          flex-wrap: wrap;
        }
        .ex-switch-btn {
          padding: 0.65rem 2rem;
          border-radius: 50px;
          font-family: 'Jost', sans-serif;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.25s;
          border: 1px solid rgba(201,168,76,0.3);
          background: transparent;
          color: rgba(255,255,255,0.5);
        }
        .ex-switch-btn.active {
          background: var(--gold);
          border-color: var(--gold);
          color: #0A0A0A;
        }
        .ex-switch-btn:hover:not(.active) {
          border-color: var(--gold);
          color: var(--gold);
        }

        /* ── TOUR HERO ── */
        .ex-tour-hero {
          position: relative;
          min-height: 70vh;
          display: flex;
          align-items: flex-end;
          overflow: hidden;
        }
        .ex-tour-bg {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transition: opacity 1.8s ease-in-out;
        }
        .ex-tour-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(10,10,10,1) 0%,
            rgba(10,10,10,0.5) 50%,
            rgba(10,10,10,0.2) 100%
          );
        }
        .ex-tour-content {
          position: relative;
          z-index: 2;
          padding: 3rem 1.5rem 4rem;
          max-width: 800px;
          animation: fadeUp 0.8s ease both;
        }
        @keyframes fadeUp {
          from { opacity:0; transform:translateY(24px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .ex-tour-tag {
          font-size: 0.62rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.8rem;
        }
        .ex-tour-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.2rem, 5vw, 4rem);
          font-weight: 700;
          color: #fff;
          line-height: 1.05;
          margin-bottom: 0.3rem;
        }
        .ex-tour-tagline {
          font-size: 0.72rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
          margin-bottom: 1.2rem;
        }
        .ex-tour-divider {
          width: 45px;
          height: 2px;
          background: var(--gold);
          margin-bottom: 1.2rem;
        }
        .ex-tour-desc {
          font-size: 1rem;
          font-weight: 300;
          color: rgba(255,255,255,0.78);
          line-height: 1.9;
          max-width: 600px;
          margin-bottom: 2rem;
        }
        .ex-tour-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 2rem;
        }
        .ex-pill {
          border: 1px solid rgba(201,168,76,0.45);
          color: var(--gold-light);
          padding: 0.3rem 1rem;
          border-radius: 50px;
          font-size: 0.72rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          font-weight: 500;
        }
        .ex-btn {
          display: inline-flex;
          align-items: center;
          background: var(--gold);
          color: #0A0A0A;
          border: none;
          padding: 0.9rem 2.6rem;
          font-family: 'Jost', sans-serif;
          font-weight: 600;
          font-size: 0.82rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          border-radius: 3px;
          cursor: pointer;
          transition: background 0.3s, transform 0.2s;
        }
        .ex-btn:hover { background: var(--gold-light); transform: translateY(-2px); }

        /* ── STATS ── */
        .ex-stats {
          background: var(--charcoal);
          border-top: 1px solid rgba(201,168,76,0.2);
          border-bottom: 1px solid rgba(201,168,76,0.2);
          padding: 1.8rem 1rem;
        }
        .ex-stat { text-align: center; padding: 0.4rem 1rem; }
        .ex-stat-n {
          font-family: 'Cormorant Garamond', serif;
          font-size: 2.2rem;
          font-weight: 700;
          color: var(--gold);
          line-height: 1;
        }
        .ex-stat-l {
          font-size: 0.65rem;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.4);
          margin-top: 0.2rem;
        }

        /* ── GALLERY ── */
        .ex-gallery {
          padding: 5rem 0 4rem;
          background: var(--dark);
        }
        .ex-label {
          font-size: 0.65rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.6rem;
        }
        .ex-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(1.8rem, 4vw, 2.8rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.4rem;
        }
        .ex-line {
          width: 40px;
          height: 2px;
          background: var(--gold);
          margin-bottom: 2.5rem;
        }
        .ex-img-frame {
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          aspect-ratio: 16/9;
          max-width: 760px;
          margin: 0 auto;
          box-shadow: 0 30px 80px rgba(0,0,0,0.6);
          border: 1px solid rgba(201,168,76,0.15);
        }
        .ex-img-frame img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity 1.4s ease-in-out;
        }
        .ex-dots {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1.4rem;
        }
        .ex-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.25);
          border: none;
          cursor: pointer;
          transition: background 0.3s, transform 0.3s;
          padding: 0;
        }
        .ex-dot.active { background: var(--gold); transform: scale(1.4); }

        /* ── ITINERARY ── */
        .ex-itinerary {
          background: var(--charcoal);
          border-top: 1px solid rgba(201,168,76,0.12);
          padding: 5rem 0 6rem;
        }
        .ex-timeline {
          max-width: 720px;
          margin: 0 auto;
          position: relative;
        }
        .ex-tl-item {
          display: flex;
          gap: 1.8rem;
          margin-bottom: 2rem;
        }
        .ex-tl-item:last-child { margin-bottom: 0; }
        .ex-tl-dot {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: rgba(201,168,76,0.08);
          border: 1px solid rgba(201,168,76,0.35);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 1.3rem;
          z-index: 1;
        }
        .ex-tl-body {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(201,168,76,0.1);
          border-radius: 6px;
          padding: 1.2rem 1.5rem;
          flex: 1;
          transition: border-color 0.3s;
        }
        .ex-tl-body:hover { border-color: rgba(201,168,76,0.4); }
        .ex-tl-time {
          font-size: 0.62rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.3rem;
        }
        .ex-tl-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.15rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.3rem;
        }
        .ex-tl-desc {
          font-size: 0.85rem;
          font-weight: 300;
          color: rgba(255,255,255,0.55);
          line-height: 1.75;
        }

        /* ── CTA ── */
        .ex-cta {
          background: linear-gradient(135deg, #1a1200 0%, #2a1f00 50%, #1a1200 100%);
          border-top: 1px solid rgba(201,168,76,0.2);
          padding: 5rem 1.5rem;
          text-align: center;
        }
        .ex-cta h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        .ex-cta p {
          font-size: 0.92rem;
          color: rgba(255,255,255,0.55);
          max-width: 480px;
          margin: 0 auto 2.5rem;
          line-height: 1.85;
        }

        @media (max-width: 576px) {
          .ex-tour-content { padding: 2.5rem 1.2rem 3.5rem; }
          .ex-timeline::before { left: 18px; }
          .ex-tl-dot { width: 36px; height: 36px; font-size: 1.1rem; }
        }
      `}</style>

      <div className="ex-root">

        {/* PAGE HERO */}
        <div className="ex-page-hero">
          <p className="ex-eyebrow">Nairobi · Kenya</p>
          <h1 className="ex-page-title">Day <em>Excursions</em></h1>
          <div className="ex-page-divider" />
          <p className="ex-page-sub">
            Venture beyond the city into Kenya's breathtaking landscapes — wildlife, lakes,
            gorges, and safari adventures all within a day's reach.
          </p>
        </div>

        {/* TOUR SWITCHER */}
        <div className="ex-switcher">
          <div className="ex-switch-wrap">
            <button
              className={`ex-switch-btn ${activeTour === "naivasha" ? "active" : ""}`}
              onClick={() => setActiveTour("naivasha")}
            >
              Naivasha Excursion
            </button>
            <button
              className={`ex-switch-btn ${activeTour === "wildlife" ? "active" : ""}`}
              onClick={() => setActiveTour("wildlife")}
            >
              Wildlife Excursion
            </button>
          </div>
        </div>

        {/* TOUR HERO */}
        <section className="ex-tour-hero" key={activeTour}>
          {active.images.map((img, i) => (
            <div
              key={i}
              className="ex-tour-bg"
              style={{ backgroundImage: `url(${img})`, opacity: i === active.currentImage ? 1 : 0 }}
            />
          ))}
          <div className="ex-tour-overlay" />
          <div className="container">
            <div className="ex-tour-content">
              <p className="ex-tour-tag">Excursion</p>
              <h2 className="ex-tour-title">{active.label}</h2>
              <p className="ex-tour-tagline">{active.tagline}</p>
              <div className="ex-tour-divider" />
              <p className="ex-tour-desc">{active.desc}</p>
              <div className="ex-tour-pills">
                {active.pills.map((p, i) => <span key={i} className="ex-pill">{p}</span>)}
              </div>
              <button className="ex-btn" onClick={() => window.location.href = "/tours"}>
                Book This Excursion
              </button>
            </div>
          </div>
        </section>

        {/* STATS */}
        <div className="ex-stats">
          <div className="container">
            <div className="row justify-content-center">
              {active.stats.map((s, i) => (
                <div key={i} className="col-6 col-md-3">
                  <div className="ex-stat">
                    <div className="ex-stat-n">{s.n}</div>
                    <div className="ex-stat-l">{s.l}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* GALLERY */}
        <section className="ex-gallery">
          <div className="container">
            <p className="ex-label">Experience Gallery</p>
            <h2 className="ex-title">{activeTour === "naivasha" ? "Lake Naivasha" : "Nairobi Wildlife"}</h2>
            <div className="ex-line" />
            <div className="ex-img-frame">
              {active.images.map((img, i) => (
                <img key={i} src={img} alt={`Excursion ${i + 1}`} style={{ opacity: i === active.currentImage ? 1 : 0 }} />
              ))}
            </div>
            <div className="ex-dots">
              {active.images.map((_, i) => (
                <button key={i} className={`ex-dot ${i === active.currentImage ? "active" : ""}`} onClick={() => active.setImage(i)} />
              ))}
            </div>
          </div>
        </section>

        {/* ITINERARY */}
        <section className="ex-itinerary">
          <div className="container">
            <p className="ex-label" style={{ textAlign: "center" }}>Your Journey</p>
            <h2 className="ex-title" style={{ textAlign: "center" }}>Full Itinerary</h2>
            <div className="ex-line" style={{ margin: "0 auto 3rem" }} />
            <div className="ex-timeline">
              {active.itinerary.map((item, i) => (
                <div key={`${activeTour}-${i}`} className="ex-tl-item">
                  <div className="ex-tl-dot">{item.icon}</div>
                  <div className="ex-tl-body">
                    <div className="ex-tl-time">{item.time}</div>
                    <div className="ex-tl-title">{item.title}</div>
                    <div className="ex-tl-desc">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="ex-cta">
          <h2>Your Adventure Awaits</h2>
          <p>
            Step beyond the city and into Kenya's wild heart.
            Book your excursion and make memories that last a lifetime.
          </p>
          <button className="ex-btn" onClick={() => window.location.href = "/tours"}>
            Book Your Experience
          </button>
        </section>

      </div>
    </>
  );
};

export default Excursions;
